var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4252 5.83594C17.8693 5.00155 16.9328 4.5 15.9298 4.5H8.07003C7.06693 4.5 6.13041 5.00155 5.57459 5.83594L2.50437 10.4418C2.17531 10.9349 2 11.5133 2 12.1058V16.5C2 18.1575 3.3434 19.5 4.9999 19.5H19.0001C20.6566 19.5 22 18.1575 22 16.5V12.1058C22 11.5133 21.8247 10.9349 21.4956 10.4418L18.4252 5.83594ZM19.7977 11.5004L16.7613 6.94594C16.5757 6.66749 16.2635 6.50062 15.9298 6.50062H8.07003C7.7363 6.50062 7.42411 6.66749 7.2385 6.94594L4.20212 11.5004H6.75756C7.55347 11.5004 8.31564 11.8164 8.87904 12.3789L9.70683 13.2076C9.89432 13.3951 10.1493 13.5001 10.4137 13.5001H13.5861C13.8505 13.5001 14.1055 13.3951 14.293 13.2076L15.1208 12.3789C15.6833 11.8164 16.4463 11.5004 17.2422 11.5004H19.7977ZM13.586 15.5007C14.3809 15.5007 15.144 15.1839 15.7065 14.6214L16.5352 13.7935C16.7227 13.606 16.9768 13.5001 17.2421 13.5001H19.9991V16.5001C19.9991 17.0523 19.5519 17.5004 18.9998 17.5004H4.99957C4.44739 17.5004 4.00022 17.0523 4.00022 16.5001V13.5001H6.75725C7.02256 13.5001 7.27661 13.606 7.4641 13.7935L8.29281 14.6214C8.85531 15.1839 9.61839 15.5007 10.4134 15.5007H13.586Z",
    fill: "#596780"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizer);
export default __webpack_public_path__ + "static/media/organizer.272ee35ad835cda4d985aca01887c884.svg";
export { ForwardRef as ReactComponent };